import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { AFFILIATE_DISCLOSURE_SHORT } from "@/lib/affiliateUtils";

const FOOTER_SECTIONS = [
  {
    title: "Buyer Guides",
    links: [
      { label: "Highest Efficiency Solar Panels", path: "/highest-efficiency-solar-panels" },
      { label: "Best High-Efficiency Panels", path: "/best-high-efficiency-solar-panels" },
      { label: "Best Solar Panels for RV", path: "/best-solar-panels-for-rv" },
      { label: "Best Portable Solar Panels", path: "/best-portable-solar-panels" },
      { label: "Best for Solar Generators", path: "/best-solar-panels-for-solar-generators" },
      { label: "Solar Panel Calculator", path: "/solar-panel-calculator" },
    ],
  },
  {
    title: "Learn",
    links: [
      { label: "All Solar Guides", path: "/solar-guides" },
      { label: "Solar Cell vs Solar Panel", path: "/solar-cell-vs-solar-panel" },
      { label: "Mono vs Polycrystalline", path: "/monocrystalline-vs-polycrystalline-solar-panels" },
      { label: "Bifacial Solar Panels", path: "/bifacial-solar-panels" },
      { label: "Flexible Solar Panels", path: "/flexible-solar-panels" },
      { label: "Solar Panel Efficiency Explained", path: "/solar-guides/solar-panel-efficiency-explained" },
    ],
  },
  {
    title: "Site",
    links: [
      { label: "Reviews", path: "/reviews" },
      { label: "About", path: "/about" },
      { label: "Contact", path: "/contact" },
      { label: "Affiliate Disclosure", path: "/affiliate-disclosure" },
      { label: "Privacy Policy", path: "/privacy-policy" },
      { label: "Terms of Use", path: "/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-accent flex items-center justify-center" style={{ boxShadow: '0 0 14px rgba(250,185,0,0.4)' }}>
                <Zap className="w-4.5 h-4.5 text-slate-950" strokeWidth={2.5} />
              </div>
              <span className="font-heading font-bold text-white">HESC</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed mb-4">
              Independent buyer's guide for high-efficiency solar panels. We help you understand solar cell technology and find the best panel for your real-world needs.
            </p>
            <p className="text-xs text-slate-500 leading-relaxed">
              {AFFILIATE_DISCLOSURE_SHORT}
            </p>
          </div>

          {/* Link Sections */}
          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title}>
              <h3 className="font-heading font-semibold text-[11px] uppercase tracking-widest mb-4 text-amber-400">
                {section.title}
              </h3>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-slate-400 hover:text-accent transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs font-mono text-slate-400">
            © {new Date().getFullYear()} highestefficiencysolarcell.com. All rights reserved.
          </p>
          <p className="text-xs font-mono text-slate-400 text-center">
            Amazon links are affiliate links · Prices may vary · We do not display fixed prices
          </p>
        </div>
      </div>
    </footer>
  );
}